module.exports = __webpack_public_path__ + "img/gas-pump.ef6f6f86.png";